export var PayloadstagingDocumentType;
(function (PayloadstagingDocumentType) {
    PayloadstagingDocumentType["UNKN"] = "UNKN";
    PayloadstagingDocumentType["SRF"] = "SRF";
    PayloadstagingDocumentType["COR"] = "COR";
    PayloadstagingDocumentType["INC"] = "INC";
    PayloadstagingDocumentType["CLM"] = "CLM";
    PayloadstagingDocumentType["ENR"] = "ENR";
    PayloadstagingDocumentType["PA"] = "PA";
    PayloadstagingDocumentType["AOB"] = "AOB";
    PayloadstagingDocumentType["OTHER"] = "OTHER";
})(PayloadstagingDocumentType || (PayloadstagingDocumentType = {}));
PayloadstagingDocumentType['UNKN'] = 'UNKN';
PayloadstagingDocumentType['SRF'] = 'SRF';
PayloadstagingDocumentType['COR'] = 'COR';
PayloadstagingDocumentType['INC'] = 'INC';
PayloadstagingDocumentType['CLM'] = 'CLM';
PayloadstagingDocumentType['ENR'] = 'ENR';
PayloadstagingDocumentType['PA'] = 'PA';
PayloadstagingDocumentType['AOB'] = 'AOB';
PayloadstagingDocumentType['OTHER'] = 'OTHER';
//# sourceMappingURL=PayloadstagingDocumentType.js.map